module.exports = __webpack_public_path__ + "img/American-Amicable_Logo_Stacked_Black.67373651.png";